export default __webpack_public_path__ + "static/147-min-min-d84ba93195748496217a7b3589c1a00e.jpg";